<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
export default {
  name: "App",
};
</script>

<style>
@media screen and (max-width:480px) {
   html {
     font-size: 100px;
   }
   div{
     font-size:0.14rem;
   }
 }

html,
body,
form {
  padding: 0;
  margin: 0;
}
#app {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

a {
  text-decoration: none;
}

img{
  vertical-align: middle;
}

.container {
  width: 1200px;
  margin: 0 auto;
}

.sub-title {
  font-size: 26px;
  font-weight: 600;
  color: #000000;
}

.sub-title-en {
  font-size: 14px;
  font-weight: 600;
  color: #999999;
  opacity: 0.5;
}

.summary-text {
  font-size: 18px;
  font-weight: 400;
  color: #333333;
  line-height: 30px;
}
</style>



// WEBPACK FOOTER //
// src/App.vue